import React from 'react'

import Center from '../../../../../packages/kiti/components/helpers/Center'
import PercentGauge from '../../../../../packages/kiti-charts/components/charts/PercentGauge'
import SeeMoreModal from './seeMoreModal/SeeMoreModal'
import Text from '../../../../../packages/kiti/components/presentation/Text'

const Chart = ({ widget, item }) => {
  const [open, setOpen] = React.useState(false)
  const { invertPerspective } = widget?.data || {}
  let percent = item.nonCompliancesCount / item.totalCount
  if (invertPerspective) {
    percent = (item.totalCount - item.nonCompliancesCount) / item.totalCount
  }

  return (
    <>
      <Center direction="column">
        <PercentGauge percent={percent} height={200} width={200} invertColors={invertPerspective} />

        <Text bold color="dark3" align="center" size="small">
          {item.name}
        </Text>

        <Text color="dark3" align="center" size="xsmall">
          {item.description}
        </Text>

        {false && (
          <Text bold color="primary" align="center" size="xsmall" onClick={() => setOpen(true)}>
            Ver Mais
          </Text>
        )}
      </Center>
      <SeeMoreModal open={open} onClose={() => setOpen(false)} />
    </>
  )
}

export default Chart
